import axios from 'axios';

const config = {
  baseURL: process.env.BASE_URL,
  headers: {
    'api-key': `${process.env.STUDENT_API_KEY}`,
  },
  'Content-Type': 'multipart/form-data',
  withCredentials: false,
};

const LOCAL_API = axios.create(config);

export default LOCAL_API;
